import React, { FC, useRef, forwardRef } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";

import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Avatar,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { localizationJapanese } from "../../common/MatelialTableLocalizationJapanese";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import {
  Button,
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import { red, green } from "@material-ui/core/colors";
import { DateTime } from "luxon";
import {
  getFirstDayOfMonth,
  getLastDayOfMonth,
} from "../Register/KeieiShindanDataOperation";
import { userLogging } from "../../../apis/userLog";
import { useHistory } from "react-router-dom";
import {
  setLastKeieiShindanId,
  setKeieiShindanId,
} from "../Register/KeieiShindan";
import { setInitTenpoCode, setFixedFlg } from "../../Header/Header";
import KeieiShindanManagerAnalysisOKButton from "./KeieiShindanManagerAnalysisOKButton";
import KeieiShindanManagerAnalysisNgButton from "./KeieiShindanManagerAnalysisNgButton";

const TAB_INDEX_OFC = 2;
const TAB_INDEX_STORE = 3;
const ITEM_ALL_VALUE = "1";

// 遵守項目の判定（big_item_id: 1,2,3）
const isComplianceItem = (bigItemId: string) =>
  bigItemId === "1" || bigItemId === "2" || bigItemId === "3";

const useStyles = makeStyles((theme: Theme) => ({
  dataTable: {
    maxWidth: "90%",
    paddingTop: "10px",
  },
  dataTableHead: {
    outlineColor: "#3e3e3e",
    backgroundColor: "#4dc0b2",
    border: "5px",
    padding: "0 0",
  },
  dataTableHeadCell: {
    textAlign: "center",
    border: "0px solid #aaa",
    padding: "0 0",
    fontSize: "12px",
    color: "white",
  },
  dataTableBody: {
    border: "1px solid #aaa",
    backgroundColor: "#ffffff",
  },
  dataTableCell: {
    width: "100px",
    textAlign: "right",
    border: "0px solid #aaa",
    paddingTop: "3px",
    paddingBottom: "3px",
    fontSize: "12px",
  },
  gray: {
    color: "#c0c0c0",
    backgroundColor: "#e6e6e6",
    width: "30px",
    height: "30px",
    boxShadow: "0px 0px 0px 1px #000 inset",
  },
  green: {
    color: "#fff",
    backgroundColor: green[500],
    width: "30px",
    height: "30px",
    boxShadow: "0px 0px 0px 1px #000 inset",
  },
  red: {
    color: "#fff",
    backgroundColor: red[500],
    width: "30px",
    height: "30px",
    boxShadow: "0px 0px 0px 1px #000 inset",
  },
}));

const KeieiShindanManagerAnalysisTable: FC<{
  data: any[];
  averageData: any;
  headerName: string;
  tableHeaderList: any[];
  tableSubmissionHeaderList: string[];
  tabValue: number;
  graphUserList?: any[];
  baseMonth: string;
  smallFlg: boolean;
  smallData: any[];
  smallAverageData: any;
  bigItemId: string;
  smallItemId: string;
  selectedTable: string;
  onClickMove?: (code: string) => void;
  onClickSelect?: (code: string, name: string) => void;
  maxScore: string;
}> = ({
  data,
  averageData,
  headerName,
  tableHeaderList,
  tableSubmissionHeaderList,
  tabValue,
  graphUserList,
  baseMonth,
  smallFlg,
  smallData,
  smallAverageData,
  bigItemId,
  smallItemId,
  selectedTable,
  onClickMove,
  onClickSelect,
  maxScore,
}) => {
  const tableRef: any = useRef();
  const classes = useStyles();
  const [sortNo, setSortNo] = React.useState(0);
  const [orderDirection, setOrderDirection] = React.useState<
    "desc" | "asc" | undefined
  >(undefined);
  const history = useHistory();
  const [sortMode, setSortMode] = React.useState(0);

  // 項目名クリック
  const moveClick = (code: string) => {
    if (onClickMove) {
      onClickMove(code);
    }
  };
  const clickSortModeCheck = (code: number) => {
    setSortMode(code);
    setOrderDirection(undefined);
  };

  const plusMinusSymbol = (score: any) => {
    if (Number(score) > 0) {
      return "+";
    }
    if (Number(score) === 0) {
      return "±";
    }
    return "";
  };
  const diffInfo = (data: any, diffKey1: any, diffKey2: any) => {
    if (diffKey1) {
      let diffKey = "";
      if (data[diffKey1] || data[diffKey1] === 0) {
        diffKey = diffKey1;
      } else {
        diffKey = diffKey2;
      }
      return "(" + plusMinusSymbol(data[diffKey]) + data[diffKey] + ")";
    }
    return "";
  };

  const realData = (data: any, key: any, diffKey1: any, diffKey2: any) => {
    if (diffKey1) {
      return (
        data[key + "Real"] +
        diffInfo(data, diffKey1, diffKey2) +
        "[" +
        data[key] +
        "%]"
      );
    } else {
      return data[key + "Real"] + "[" + data[key] + "%]";
    }
  };

  const kobetuData = (data: any, key: any, diffKey1: any, diffKey2: any) => {
    if (diffKey1) {
      return data[key + "Real"] + "[" + data[key] + "%]";
    } else {
      return data[key];
    }
  };

  // big_item 1-3用の表示フォーマット (OK数/全項目数)
  const formatOkCountDisplay = (
    score: any,
    maxScore: string,
    rowData?: any,
    diffKey1?: string,
    diffKey2?: string
  ) => {
    // 既に分数形式（例: "3/3"）の場合はそのまま使用
    let display: string;
    if (typeof score === 'string' && score.includes('/')) {
      display = score;
    } else {
      const okCount = Math.round(Number(score) || 0);
      const totalCount = maxScore;
      display = okCount + "/" + totalCount;
    }

    if (diffKey1 && rowData) {
      return display + diffInfo(rowData, diffKey1, diffKey2);
    }
    return display;
  };

  // 個店別分析用の表示フォーマット（分子のみ＋差分）
  const formatOkCountOnlyDisplay = (
    score: any,
    rowData?: any,
    diffKey1?: string,
    diffKey2?: string
  ) => {
    // 分子のみを表示
    const okCount = Math.round(Number(score) || 0);
    let display = String(okCount);

    if (diffKey1 && rowData) {
      return display + diffInfo(rowData, diffKey1, diffKey2);
    }
    return display;
  };

  const getColumnsList = () => {
    let resultList: any[] = [];
    const ofcColumn = {
      title: "OFC",
      field: "ofcName",
      cellStyle: {
        width: "300px",
      },
      sorting: false,
      render: (rowData: any) => {
        return rowData.ofcName;
      },
    };
    const nameColumn = {
      title: headerName,
      field: "name",
      cellStyle: {
        width: "300px",
      },
      sorting: false,
      render: (rowData: any) => {
        return rowData.code !== "average" && tabValue !== TAB_INDEX_STORE ? (
          <Link
            style={{ cursor: "pointer" }}
            onClick={() => moveClick(rowData.code)}
            color="primary"
          >
            {rowData.name}
          </Link>
        ) : (
          rowData.name
        );
      },
    };
    // 基準月列のデータ
    let baseMonthColumn = {
      title: baseMonth ? "(基)" + baseMonth : "基準月",
      field: "baseMonthScore",
      align: "center",
      type: "numeric",
      defaultSort: sortNo === 1 && orderDirection ? orderDirection : undefined,
      render: (rowData: any) => {
        let displayData = "";
        const isBigItem123 = isComplianceItem(bigItemId);

        // 小項目全体を選択
        if (!smallFlg) {
          // データなし
          if (
            rowData["baseMonthScore"] === undefined ||
            rowData["baseMonthScore"] === ""
          ) {
            displayData = "";
          }
          // 総合以外を選択 かつ データあり
          else if (selectedTable !== ITEM_ALL_VALUE) {
            // big_item 1-3の場合は「OK数/全項目数」形式
            if (isBigItem123) {
              // baseMonthScoreRealが既に分数形式の場合はそのまま使用
              if (typeof rowData["baseMonthScoreReal"] === 'string' && rowData["baseMonthScoreReal"].includes('/')) {
                displayData = rowData["baseMonthScoreReal"];
              } else {
                displayData = formatOkCountDisplay(rowData["baseMonthScoreReal"], rowData["baseMonthMaxCount"] || maxScore);
              }
            } else {
              displayData =
                rowData["baseMonthScoreReal"] +
                "[" +
                rowData["baseMonthScore"] +
                "%]";
            }
          } else {
            displayData = rowData["baseMonthScore"];
          }
        }
        // 小項目選択 かつ データあり
        else if (rowData["baseMonthScore"] || rowData["baseMonthScore"] === 0) {
          // 個店別分析タブ以外 かつ データあり
          if (tabValue !== TAB_INDEX_STORE) {
            // big_item 1-3の場合は「OK数/全項目数」形式
            if (isBigItem123) {
              // baseMonthScoreRealが既に分数形式の場合はそのまま使用
              if (typeof rowData["baseMonthScoreReal"] === 'string' && rowData["baseMonthScoreReal"].includes('/')) {
                displayData = rowData["baseMonthScoreReal"];
              } else {
                displayData = formatOkCountDisplay(rowData["baseMonthScoreReal"], rowData["baseMonthMaxCount"] || maxScore);
              }
            } else {
              displayData =
                rowData["baseMonthScoreReal"] +
                "[" +
                rowData["baseMonthScore"] +
                "%]";
            }
          } else {
            // 個店別分析タブの場合
            // big_item_id 1-3は〇×表示、それ以外は数値表示
            if (isComplianceItem(bigItemId)) {
              // 基準月の場合はidBaseを使用
              if (rowData["idBase"]) {
                return Number(rowData["baseMonthScore"]) === 0 ? (
                  <Avatar className={classes.red}>
                    <KeieiShindanManagerAnalysisNgButton
                      id={rowData["idBase"]}
                      bigItemId={bigItemId}
                      smallItemId={smallItemId}
                    />
                  </Avatar>
                ) : (
                  <Avatar className={classes.green}>
                    <KeieiShindanManagerAnalysisOKButton
                      id={rowData["idBase"]}
                      bigItemId={bigItemId}
                      smallItemId={smallItemId}
                    />
                  </Avatar>
                );
              } else {
                return "";
              }
            } else {
              displayData = rowData["baseMonthScore"];
            }
          }
        }
        // 小項目選択 かつ データなし
        else {
          displayData = "";
        }
        return displayData;
      },
    };

    const monthColumn: Array<any> = [];
    for (let i = 0; i < 5; i++) {
      const headerNo = i;
      const diffNo = i + 1;
      let diff = diffNo + "wDiff";
      let diffBase = diffNo + "wDiffBase";
      if (selectedTable !== "1") {
        diff = diffNo + "wDiffReal";
        diffBase = diffNo + "wDiffBaseReal";
      }
      const tableHedder = tableHeaderList[headerNo];
      monthColumn.push({
        title: tableHedder,
        field: tableHedder,
        align: "center",
        type: "numeric",
        defaultSort:
          sortNo === i + 2 && orderDirection ? orderDirection : undefined,
        customSort: (a: any, b: any) => {
          return sortMode === 1 && !(smallFlg && tabValue === TAB_INDEX_STORE)
            ? a[diffBase] || a[diffBase] === 0
              ? Number(a[diffBase]) - Number(b[diffBase])
              : Number(a[diff]) - Number(b[diff])
            : Number(a[tableHedder]) - Number(b[tableHedder]);
        },
        render: (rowData: any) => {
          // big_item 1-3の場合は「OK数/全項目数」形式で表示（小項目選択時以外）
          const isBigItem123 = isComplianceItem(bigItemId);

          return tabValue !== TAB_INDEX_STORE ||
            (tabValue === TAB_INDEX_STORE &&
              !smallFlg &&
              !rowData[tableSubmissionHeaderList[i] + "_" + "id"]) ? (
            // ZO別/DO別/OFC別分析、または個店別で小項目未選択時
            isBigItem123 && selectedTable !== ITEM_ALL_VALUE ? (
              formatOkCountDisplay(rowData[tableHedder + "Real"], maxScore, rowData, diffBase, diff)
            ) : selectedTable !== ITEM_ALL_VALUE ? (
              realData(rowData, tableHedder, diffBase, diff)
            ) : (
              rowData[tableHedder] + diffInfo(rowData, diffBase, diff)
            )
          ) : !smallFlg ? (
            <Link
              style={{ cursor: "pointer" }}
              onClick={() =>
                clickTenpoScore(
                  rowData[tableSubmissionHeaderList[i] + "_" + "id"],
                  rowData[tableSubmissionHeaderList[i] + "_" + "doc_last_id"],
                  rowData["tenpo_code"]
                )
              }
              color="primary"
            >
              {isBigItem123 && selectedTable !== ITEM_ALL_VALUE
                ? formatOkCountDisplay(rowData[tableHedder + "Real"], maxScore, rowData, diffBase, diff)
                : selectedTable !== ITEM_ALL_VALUE
                ? realData(rowData, tableHedder, diffBase, diff)
                : rowData[tableHedder] + diffInfo(rowData, diffBase, diff)}
            </Link>
          ) : (
            // 小項目選択時: big_item_id 1-3の場合は〇×表示、それ以外は数値表示
            (() => {
              // カラムのインデックスとIDのマッピングを修正
              // i=0 → 2026年2月 (最古週) → id1 (result5のID)
              // i=4 → 2026年6月 (最新週) → id5 (result1のID)
              const idKey = "id" + (i + 1);
              const hasId = rowData[idKey];
              const scoreValue = Number(rowData[tableHedder]);

              const isComplianceItemFlag = isComplianceItem(bigItemId);

              if (!isComplianceItemFlag) {
                return rowData[tableHedder];
              }

              if (!hasId) {
                return "";
              }

              return scoreValue === 0 ? (
                <Avatar className={classes.red}>
                  <KeieiShindanManagerAnalysisNgButton
                    id={rowData[idKey]}
                    bigItemId={bigItemId}
                    smallItemId={smallItemId}
                  />
                </Avatar>
              ) : (
                <Avatar className={classes.green}>
                  <KeieiShindanManagerAnalysisOKButton
                    id={rowData[idKey]}
                    bigItemId={bigItemId}
                    smallItemId={smallItemId}
                  />
                </Avatar>
              );
            })()
          );
        },
      });
    }

    // 提出数カラム
    // 提出数カラムはOFC分析(tabValue === 2)の場合のみ出力
    const submissionColumn: Array<any> = [];
    for (let i = 0; i < 5; i++) {
      submissionColumn.push({
        // title: convertDateTitle(tableSubmissionHeaderList[i]),
        title: "",
        field: tableSubmissionHeaderList[i],
        maxWidth: 300,
        sorting: false,
        align: "left",
        render: (rowData: any) => {
          return rowData[tableSubmissionHeaderList[i]] !== "0" ? (
            <Link
              style={{ cursor: "pointer" }}
              onClick={() =>
                clickSubmissionsCount(
                  tableSubmissionHeaderList[i],
                  rowData["ofc_mailaddress"]
                )
              }
              color="primary"
            >
              {rowData[tableSubmissionHeaderList[i]]}&#047;
              {rowData["tenpo_count"]}
            </Link>
          ) : (
            <>
              {rowData[tableSubmissionHeaderList[i]]}&#047;
              {rowData["tenpo_count"]}
            </>
          );
        },
      });
    }

    const selectColumn = {
      title: "",
      field: "",
      align: "center",
      sorting: false,
      render: (rowData: any) => {
        return !smallFlg ? (
          <Button
            variant="contained"
            color={checkedGraphUser(rowData.code) ? "secondary" : "primary"}
            size="small"
            style={{ padding: "0" }}
            onClick={() => selectClick(rowData.code, rowData.name)}
          >
            選択
          </Button>
        ) : (
          ""
        );
      },
    };

    if (tabValue === TAB_INDEX_STORE) {
      resultList.push(ofcColumn);
    }
    resultList.push(nameColumn);
    resultList.push(baseMonthColumn);
    if (tabValue === TAB_INDEX_OFC) {
      for (let i = 0; i < 5; i++) {
        resultList.push(monthColumn[i]);
        resultList.push(submissionColumn[i]);
      }
    } else {
      for (let i = 0; i < 5; i++) {
        resultList.push(monthColumn[i]);
      }
    }
    resultList.push(selectColumn);

    return resultList;
  };

  // 選択をクリック
  const selectClick = (code: string, name: string) => {
    if (onClickSelect) {
      onClickSelect(code, name);
    }
  };

  // 選択中か判定
  const checkedGraphUser = (code: string) => {
    if (graphUserList) {
      for (let i = 0; i < graphUserList.length; i++) {
        if (graphUserList[i].code === code) {
          return true;
        }
      }
    }
    return false;
  };

  // 対象OFCの店舗の検索に遷移
  const clickSubmissionsCount = (dateString: any, ofcAddress: string) => {
    const targetDateTime = DateTime.fromFormat(dateString, "yyyy/MM/dd");
    const jsDate = targetDateTime.toJSDate();
    const fromDate: DateTime = DateTime.fromFormat(
      getFirstDayOfMonth(jsDate.toISOString(), 0),
      "yyyyMMdd"
    );
    const toDate: DateTime = DateTime.fromFormat(
      getLastDayOfMonth(jsDate.toISOString(), 1),
      "yyyyMMdd"
    );

    const paramState = {
      ofcAddress: ofcAddress,
      createdateFrom: fromDate,
      createdateTo: toDate,
    };
    history.push({
      pathname: "keiei-shindan-search",
      state: paramState,
    });
    userLogging("KeieiShindan", "管理者分析#検索画面へ遷移", "データ検索");
  };

  // 対象KeieiShindanに遷移
  const clickTenpoScore = (
    keieiShindanId: string,
    lastKeieiShindanId: string,
    tenpoCode: string
  ) => {
    setFixedFlg(true);
    setLastKeieiShindanId(lastKeieiShindanId);
    setKeieiShindanId(keieiShindanId);
    setInitTenpoCode(tenpoCode);
    // 画面遷移
    history.push("keiei-shindan");
    userLogging(
      "KeieiShindan",
      "管理者分析#検索画面へ遷移",
      "KeieiShindanID: " + keieiShindanId
    );
  };
  let baseScorekey = "";

  return (
    <Grid container justify="center" alignItems="center">
      {!smallFlg ? (
        <>
          <Grid container justify="center" alignItems="center">
            <Table className={classes.dataTable}>
              <TableHead className={classes.dataTableHead}>
                <TableCell
                  className={classes.dataTableHeadCell}
                  style={{
                    width: "300px",
                  }}
                >
                  {headerName}
                </TableCell>
                <TableCell className={classes.dataTableHeadCell}>
                  <Typography style={{ fontSize: "12px" }}>
                    {baseMonth ? "(基)" + baseMonth : "基準月"}
                  </Typography>
                </TableCell>
                {tableHeaderList.map((row) => (
                  <TableCell className={classes.dataTableHeadCell}>
                    {row}
                  </TableCell>
                ))}
                <TableCell className={classes.dataTableHeadCell}></TableCell>
              </TableHead>
              <TableBody className={classes.dataTableBody}>
                <TableRow>
                  <TableCell
                    className={classes.dataTableCell}
                    style={{ textAlign: "left" }}
                  >
                    {averageData.name}
                  </TableCell>
                  <TableCell className={classes.dataTableCell}>
                    {averageData.baseMonthScore === undefined ||
                    averageData.baseMonthScore === ""
                      ? ""
                      : selectedTable !== ITEM_ALL_VALUE
                      ? (isComplianceItem(bigItemId))
                        ? (typeof averageData.baseMonthScoreReal === 'string' && averageData.baseMonthScoreReal.includes('/')
                          ? averageData.baseMonthScoreReal
                          : formatOkCountDisplay(averageData.baseMonthScoreReal, averageData.baseMonthMaxCount || maxScore))
                        : realData(averageData, "baseMonthScore", "", "")
                      : averageData.baseMonthScore}
                  </TableCell>
                  {tableHeaderList.map((itemName, i) => (
                    <TableCell className={classes.dataTableCell}>
                      {selectedTable !== ITEM_ALL_VALUE
                        ? (isComplianceItem(bigItemId))
                          ? formatOkCountDisplay(
                              averageData[itemName + "Real"],
                              maxScore,
                              averageData,
                              i + 1 + "wDiffBaseReal",
                              i + 1 + "wDiffReal"
                            )
                          : realData(
                              averageData,
                              itemName,
                              i + 1 + "wDiffBaseReal",
                              i + 1 + "wDiffReal"
                            )
                        : averageData[itemName] +
                          diffInfo(
                            averageData,
                            i + 1 + "wDiffBase",
                            i + 1 + "wDiff"
                          )}
                    </TableCell>
                  ))}

                  <TableCell className={classes.dataTableCell}>
                    <Button
                      variant="contained"
                      color={
                        checkedGraphUser(averageData.code)
                          ? "secondary"
                          : "primary"
                      }
                      size="small"
                      style={{ padding: "0" }}
                      onClick={() =>
                        selectClick(averageData.code, averageData.name)
                      }
                    >
                      選択
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </>
      ) : (
        <>
          <Grid container justify="center" alignItems="center">
            <Table className={classes.dataTable}>
              <TableHead className={classes.dataTableHead}>
                <TableCell
                  className={classes.dataTableHeadCell}
                  style={{
                    width: "300px",
                  }}
                >
                  {headerName}
                </TableCell>
                <TableCell className={classes.dataTableHeadCell}>
                  <Typography style={{ fontSize: "12px" }}>
                    {baseMonth ? "(基)" + baseMonth : "基準月"}
                  </Typography>
                </TableCell>
                {tableHeaderList.map((row) => (
                  <TableCell className={classes.dataTableHeadCell}>
                    {row}
                  </TableCell>
                ))}
                <TableCell className={classes.dataTableHeadCell}></TableCell>
              </TableHead>
              <TableBody className={classes.dataTableBody}>
                <TableRow>
                  <TableCell
                    className={classes.dataTableCell}
                    style={{ textAlign: "left" }}
                  >
                    {smallAverageData.name}
                  </TableCell>
                  <TableCell className={classes.dataTableCell}>
                    {smallAverageData.baseMonthScoreReal ||
                    smallAverageData.baseMonthScoreReal === 0
                      ? selectedTable !== "1"
                        ? (isComplianceItem(bigItemId))
                          ? tabValue === TAB_INDEX_STORE
                            ? formatOkCountOnlyDisplay(smallAverageData.baseMonthScoreReal)
                            : (typeof smallAverageData.baseMonthScoreReal === 'string' && smallAverageData.baseMonthScoreReal.includes('/')
                              ? smallAverageData.baseMonthScoreReal
                              : formatOkCountDisplay(smallAverageData.baseMonthScoreReal, smallAverageData.baseMonthMaxCount || maxScore))
                          : realData(smallAverageData, "baseMonthScore", "", "")
                        : smallAverageData.baseMonthScore
                      : ""}
                  </TableCell>
                  {tableHeaderList.map((itemName, i) => (
                    <TableCell className={classes.dataTableCell}>
                      {tabValue === TAB_INDEX_STORE
                        ? (isComplianceItem(bigItemId))
                          ? formatOkCountOnlyDisplay(
                              smallAverageData[itemName + "Real"],
                              smallAverageData,
                              i + 1 + "wDiffBaseReal",
                              i + 1 + "wDiffReal"
                            )
                          : kobetuData(
                              smallAverageData,
                              itemName,
                              i + 1 + "wDiffBase",
                              i + 1 + "wDiff"
                            )
                        : (isComplianceItem(bigItemId))
                          ? formatOkCountDisplay(
                              smallAverageData[itemName + "Real"],
                              maxScore,
                              smallAverageData,
                              i + 1 + "wDiffBaseReal",
                              i + 1 + "wDiffReal"
                            )
                          : realData(
                              smallAverageData,
                              itemName,
                              i + 1 + "wDiffBaseReal",
                              i + 1 + "wDiffReal"
                            )}
                    </TableCell>
                  ))}
                  <TableCell className={classes.dataTableCell}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </>
      )}

      {smallFlg && tabValue === TAB_INDEX_STORE ? (
        <Grid container>
          <Grid item lg={10} md={10} sm={9}></Grid>
          <Grid item style={{ paddingTop: "12px", paddingLeft: "30px" }}>
            {maxScore && !(isComplianceItem(bigItemId))
              ? "【" + maxScore + "点満点】"
              : ""}
          </Grid>
        </Grid>
      ) : (
        <Grid container style={{ paddingLeft: "30px" }}>
          <Grid item lg={10} md={10} sm={9}>
            <FormControl>
              <RadioGroup
                aria-labelledby="sortGroupLabel"
                defaultValue={0}
                name="sortGroup"
                value={sortMode}
              >
                <Grid container>
                  <Grid
                    item
                    style={{ paddingTop: "6px", paddingRight: "10px" }}
                  >
                    <FormLabel id="sortGroupLabel">
                      <Typography variant="caption">ソート対象：</Typography>
                    </FormLabel>
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      value="timeComp"
                      control={
                        <Radio
                          value={0}
                          size="small"
                          onClick={(event) => {
                            clickSortModeCheck(0);
                          }}
                        />
                      }
                      label={<Typography variant="caption">点数</Typography>}
                    />
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      value="timeComp"
                      control={
                        <Radio
                          value={1}
                          size="small"
                          onClick={(event) => {
                            clickSortModeCheck(1);
                          }}
                        />
                      }
                      label={<Typography variant="caption">前月差</Typography>}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingTop: "12px", paddingLeft: "30px" }}>
            {maxScore && !(isComplianceItem(bigItemId))
              ? "【" + maxScore + "点満点】"
              : ""}
          </Grid>
        </Grid>
      )}

      <Grid container justify="center" alignItems="center">
        <MaterialTable
          tableRef={tableRef}
          data={
            !smallFlg
              ? JSON.parse(JSON.stringify(data))
              : JSON.parse(JSON.stringify(smallData))
          }
          columns={getColumnsList()}
          style={{ width: "90%" }}
          components={{
            Pagination: (props) => (
              <TablePagination {...props} rowsPerPageOptions={[5, 10, 15]} />
            ),
          }}
          icons={{
            Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
            Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
            Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
            Delete: forwardRef((props, ref) => (
              <DeleteOutline {...props} ref={ref} />
            )),
            DetailPanel: forwardRef((props, ref) => (
              <ChevronRight {...props} ref={ref} />
            )),
            Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
            Export: forwardRef((props, ref) => (
              <SaveAlt {...props} ref={ref} />
            )),
            Filter: forwardRef((props, ref) => (
              <FilterList {...props} ref={ref} />
            )),
            FirstPage: forwardRef((props, ref) => (
              <FirstPage {...props} ref={ref} />
            )),
            LastPage: forwardRef((props, ref) => (
              <LastPage {...props} ref={ref} />
            )),
            NextPage: forwardRef((props, ref) => (
              <ChevronRight {...props} ref={ref} />
            )),
            PreviousPage: forwardRef((props, ref) => (
              <ChevronLeft {...props} ref={ref} />
            )),
            ResetSearch: forwardRef((props, ref) => (
              <Clear {...props} ref={ref} />
            )),
            Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
            SortArrow: forwardRef((props, ref) => (
              <ArrowDownward {...props} ref={ref} />
            )),
            ThirdStateCheck: forwardRef((props, ref) => (
              <Remove {...props} ref={ref} />
            )),
            ViewColumn: forwardRef((props, ref) => (
              <ViewColumn {...props} ref={ref} />
            )),
          }}
          onOrderChange={(orderBy: number, orderDirection: "asc" | "desc") => {
            // OFC別分析タブのカラム数のズレを補正
            if (tabValue === TAB_INDEX_OFC) {
              if (orderBy === 4) {
                orderBy = 3;
              } else if (orderBy === 6) {
                orderBy = 4;
              } else if (orderBy === 8) {
                orderBy = 5;
              } else if (orderBy === 10) {
                orderBy = 6;
              }
            }
            // 個店別別分析タブのカラム数のズレを補正
            else if (tabValue === TAB_INDEX_STORE) {
              orderBy = orderBy - 1;
            }
            setSortNo(orderBy);
            setOrderDirection(orderDirection);
          }}
          localization={localizationJapanese}
          options={{
            padding: "dense",
            draggable: false,
            search: false,
            showTitle: false,
            toolbar: false,
            filtering: false,
            paging: false,
            // 対象外の場合はcsv出力ボタン非表示
            exportButton: false,
            headerStyle: {
              backgroundColor: "#4dc0b2",
              color: "#ffffff",
              whiteSpace: "nowrap",
              paddingLeft: "14px",
              paddingRight: "14px",
            },
            rowStyle: {
              fontSize: "12px",
              whiteSpace: "nowrap",
            },
          }}
        ></MaterialTable>
      </Grid>
      <Grid container style={{ padding: "10px" }}></Grid>
    </Grid>
  );
};

export default KeieiShindanManagerAnalysisTable;
